/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FavoritesIcon = createIcon("FavoritesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.456 1.25 2.09 4.143 4.026.399a.503.503 0 01.312.859l-3.312 3.283 1.228 4.461a.508.508 0 01-.72.584L8 12.96l-4.075 2.018a.508.508 0 01-.72-.585l1.229-4.46-3.315-3.284a.503.503 0 01.312-.859l4.025-.398L7.544 1.25a.512.512 0 01.912 0Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});